import ProjectNavBar from "../projectnavbar/projectnavbar";

function Myproject()
{

    return (
       <>
        <ProjectNavBar></ProjectNavBar>
       </>
    );
}

export default Myproject ;